<template>
  <div v-loading="loading"
       element-loading-text="加载中"
       element-loading-spinner="el-icon-loading"
       class="main"
       :style="examConfig.backgroundImg ? 'background: url(' + examConfig.backgroundImg + ')' : ''">
    <div class="panel">
      <div class="title">{{ userExamPaperTextConfig.title }}</div>
      <el-table
          :data="userExamPaperList"
          style="width: 100%; font-size: 14px">
        <el-table-column
            prop="examPaperName"
            :label="tableTextConfig.examPaperName"
            width="180">
        </el-table-column>
        <el-table-column
            prop="subject"
            :label="tableTextConfig.subject"
            width="180">
        </el-table-column>
        <el-table-column
            prop="examDuration"
            :label="tableTextConfig.examDuration"
            :formatter="examDurationFormatter"
            width="120">
        </el-table-column>
        <el-table-column
            prop="takeTime"
            :label="tableTextConfig.takeTime"
            :formatter="takeTimeFormatter"
            width="120">
        </el-table-column>
        <el-table-column
            prop="commitDate"
            :label="tableTextConfig.commitDate"
            width="180">
        </el-table-column>
        <el-table-column
            :label="tableTextConfig.operate">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.disabled" @click="startExam(scope.row.examPaperId)" type="primary" plain
                       size="small" style="margin-right: 10px">
              {{ tableButtonTextConfig.exam }}
            </el-button>
            <el-button @click="goResult(scope.row)" v-if="scope.row.examIsDisplayScore"
                       :disabled="!scope.row.commitDate" type="primary" plain size="small"
                       style="margin-left: 0; margin-top: 5px">{{ tableButtonTextConfig.result }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "userExamPaper",
  props: ['examConfig', 'userExamPaperList', 'examDurationUnitOptions', 'loading'],
  computed: {
    showQuestionScore() {
      return this.$store.state.global.textConfig.showQuestionScore
    },
    userExamPaperTextConfig() {
      return this.$store.state.global.textConfig.frontend.candidate.userExamPaper
    },
    tableTextConfig() {
      return this.userExamPaperTextConfig.table
    },
    tableButtonTextConfig() {
      return this.tableTextConfig.button
    }
  },
  methods: {
    startExam(examPaperId) {
      this.$emit('start', examPaperId);
    },
    goResult(row) {
      let param = {
        examPaperId: row.examPaperId,
        answerSheetId: row.answerSheetId,
        examCategory: row.examCategory,
        examIsDisplayScore: row.examIsDisplayScore,
        examIsDisplayAnswer: row.examIsDisplayAnswer,
        examEndTime: row.examEndTime,
        timeDifference: row.timeDifference,
        isExaminee: true,
        showQuestionScore: this.showQuestionScore
      }
      localStorage.setItem('setExamineePaperInfo', JSON.stringify(param))
      this.$router.push('/reviewDetails')
    },
    examDurationFormatter(row) {
      let already = this.examDurationUnitOptions.find(item => item.dict_value === row.examDurationUnit)
      return already ? row.examDuration + already.dict_label : row.examDuration
    },
    takeTimeFormatter(row) {
      return row.takeTime != null ? row.takeTime + "分钟" : ''
    }
  }
}
</script>

<style scoped>
.panel {
  width: 1100px;
  padding: 40px;
  border-radius: 15px;
  background: #fff;
  position: relative;
  z-index: 1;
}

.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
